module.exports = __webpack_public_path__ + "img/lessontake_resources_image_operate.b856a039.svg";